// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import MintUI from './js/mint-ui'
import './js/mint-ui/lib/style.css'
import App from './App'
import router from './router'
import navbar from './components/common/navbar/navigationbar'
import store from './js/store/store'
import utils from './js/utils'
import VueResource from 'vue-resource'
import VueTouch from 'vue-touch'

Vue.use(VueTouch, {name: 'v-touch'})

Vue.config.productionTip = false

Vue.use(VueResource)
// 使用百度地图
// Vue.use(BaiduMap, {
//   ak: 'kG0GHj7Kn2EzPRsRhog4BvWW5zoEskNl'
// })
// 使用mintui
Vue.use(MintUI)
// 注册vuex
Vue.use(Vuex)
// 注册全局的navbar
Vue.component('navbar', navbar)
// 公共方法
Vue.prototype.utils = utils
// MintUI全局引用
Vue.prototype.MintUI = MintUI
Vue.prototype.$Vue = Vue
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js